module.exports = {
  siteTitle: 'Wasescha Maler', // <title>
  manifestName: 'Wasescha Maler',
  manifestShortName: 'WM', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#146fb7',
  manifestThemeColor: '#146fb7',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/Logo-WM.png',
  heading: 'Wasescha Maler',
  subHeading: 'Maler aus Leidenschaft – im Val Surses zu Hause.  ',

  // social
  socialLinks: [
    // {
    //   icon: 'fa-linkedin-in',
    //   name: 'Linkedin',
    //   url: '',
    // },
    // {
    //   icon: 'fa-twitter',
    //   name: 'Twitter',
    //   url: '',
    // },
  ],
  email: 'info@waseschamaler.ch',
  phone: 'Tel. +41 (0) 81 558 98 99 | Mob. +41 (0) 79 263 77 06',
  address: 'Gravas 6, 7452 Cunter',
};
